import {
  VideoPlayerManager,
  VideoPlayerManagerContext,
} from "@src/utils/VideoPlayerManager";
import { type PropsWithChildren } from "react";

const videoPlayer = new VideoPlayerManager();

export const VideoManagerProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <VideoPlayerManagerContext.Provider value={videoPlayer}>
      {children}
    </VideoPlayerManagerContext.Provider>
  );
};
